"use strict";
import factory from './injectorFactory';
export default factory();


/** WEBPACK FOOTER **
 ** ./~/subschema-injection/src/injector.js
 **/